import { Directive, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Dialog } from 'primeng/dialog';

/**
 * Names the close button PrimeNG renders in every `p-dialog` header.
 *
 * `closeAriaLabel` has no default, so the X ships as an unnamed button: a screen
 * reader announces just "button" and there is no text inside it to fall back on.
 * Every dialog in the app hides the built-in `header` behind a `#header`
 * template, which names the dialog but not its button.
 *
 * Applied by selector so it cannot be forgotten on a new dialog; the
 * `:not([closeAriaLabel])` guard steps aside whenever a dialog sets its own.
 */
@Directive({ selector: 'p-dialog:not([closeAriaLabel])' })
export class DialogCloseLabelDirective {
	constructor() {
		// Set in the constructor: the dialog reads the field while rendering its
		// header, which for a dialog opened later happens after any ngOnInit.
		inject(Dialog).closeAriaLabel = inject(TranslocoService).translate('common.actions.close');
	}
}
